import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=12ffbf8c"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileTablePanel: require('/home/vsts/work/1/s/components/profile/TablePanel.vue').default})
